import { render, staticRenderFns } from "./profile-select.vue?vue&type=template&id=40e8d3d6"
import script from "./profile-select.vue?vue&type=script&lang=js"
export * from "./profile-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40e8d3d6')) {
      api.createRecord('40e8d3d6', component.options)
    } else {
      api.reload('40e8d3d6', component.options)
    }
    module.hot.accept("./profile-select.vue?vue&type=template&id=40e8d3d6", function () {
      api.rerender('40e8d3d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/selects/profile-select.vue"
export default component.exports